import React from 'react'
import createSvgIcon from 'client/icons/createSvgIcon'

export default createSvgIcon(
  <path d="M19 6H16.5V4C16.5 2.9 15.6 2 14.5 2H9.5C8.4 2 7.5 2.9 7.5 4V6H5C3.35 6 2 7.35 2 9V19C2 20.65 3.35 22 5 22H19C20.65 22 22 20.65 22 19V9C22 7.35 20.65 6 19 6ZM9.5 4H14.5V6H9.5V4ZM5 8H19C19.55 8 20 8.45 20 9V11.2L12 12.98L4 11.2V9C4 8.45 4.45 8 5 8ZM19 20H5C4.45 20 4 19.55 4 19V13.25L11.78 14.98C11.85 15 11.92 15 12 15C12.08 15 12.15 15 12.22 14.98L20 13.25V19C20 19.55 19.55 20 19 20Z" />,
  'BusinessServices'
)
